import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoaderModule } from '®shared/loader';

import { ItemModeResolverComponent } from './item-mode-resolver.component';

@NgModule({
  imports: [CommonModule, LoaderModule, RouterModule],
  declarations: [ItemModeResolverComponent],
  exports: [ItemModeResolverComponent],
})
export class ItemModeResolverModule {}
